<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-112"
    customWidth="lg:w-120"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Trash2" class="w-4 h-4 mr-1 stroke-error" />
          <div class="text-sm font-inter font-semibold text-error">Confirm</div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Deleting {{ props.modal_config.record_name }}
        </div>
      </div>
    </template>

    <template #modal-body>
      <div class="p-6 text-error text-lg">
        You are choosing to delete the
        {{ props.modal_config.type == "joint_contact" ? "joint contact" : "entity account" }}:
        {{ props.modal_config.record_name }}. This action cannot be undone.
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
        <Button @click="handleConfirm()" variant="primary-grey" size="sm" class="">
          <template #label>Confirm</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
//IMPORTS
import { Modal, Icon, Button } from "@/components";
import { useCrudStore } from "@/stores";

//STORES
const crudStore = useCrudStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "deleted"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

// COMPONENT LOGIC AND FUNCTIONS
async function handleConfirm() {
  let query = [
    {
      field_name: "record_id",
      operator: "eq",
      value: props.modal_config.record_id,
    },
  ];

  let table = "contacts";
  if (props.modal_config.type == "entity_account") {
    table = "accounts";
  }

  await crudStore.delete(table, query);

  emit("deleted", {
    type: props.modal_config.type, // "joint_contact" | "entity_account"
    record_id: props.modal_config.record_id,
  });

  emit("close-modal");
}
</script>
